import { render, staticRenderFns } from "./DataIdentitas.vue?vue&type=template&id=a2bba936&"
import script from "./DataIdentitas.vue?vue&type=script&lang=js&"
export * from "./DataIdentitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports